import { IOutputSensorTypeResponse } from '@kcftech/prometheustypescriptapiclient';
import { Dropdown } from 'components/dropdown/Dropdown';
import { formatSensorRole } from 'pages/Settings/ThirdPartySensorModels/shared';
import { dropdownTriggerStyles } from 'pages/Settings/ThirdPartySensorModels/styled';
import { useOutputDataStreamTypes } from 'pages/Settings/ThirdPartySensorModels/useOutputDataStreamTypes';
import { useThemeValues } from 'styles/theme';
import { insertSpacesOnCaseChange } from 'utils/string';

const renderItem = (item: IOutputSensorTypeResponse) =>
    `${insertSpacesOnCaseChange(item.CommonType)}, ${formatSensorRole(item.RoleCode)}`;

export type OutputDataStreamTypeDropdownProps = Readonly<{
    dataTypeId?: number;
    value: IOutputSensorTypeResponse | undefined;
    onChange: (newValue: IOutputSensorTypeResponse | undefined) => void;
}>;

export function OutputDataStreamTypeDropdown({
    dataTypeId,
    value,
    onChange,
}: OutputDataStreamTypeDropdownProps) {
    const { shadeBackgroundColor, borderColor } = useThemeValues();
    const { data } = useOutputDataStreamTypes({ dataTypeId });

    return (
        <Dropdown<IOutputSensorTypeResponse>
            isDisabled={dataTypeId === undefined}
            trigger={{
                style: {
                    ...dropdownTriggerStyles,
                    backgroundColor: shadeBackgroundColor,
                    border: `2px solid ${borderColor}`,
                },
            }}
            dataKey={(item) => `${item.CommonType}-${item.RoleCode}`}
            data={data}
            value={value}
            renderItem={({ item }) => renderItem(item)}
            renderLabel={() =>
                value ? renderItem(value) : 'Select an output data stream type'
            }
            onChange={onChange}
        />
    );
}
